export var MESSAGE_SHOW = 'messageShow';
export var MESSAGE_HIDE = 'messageHide';
export var TAN_REQUEST_START = 'TAN_REQUEST_START';
export var TAN_REQUEST_SUCCESS = 'TAN_REQUEST_SUCCESS';
export var TAN_REQUEST_FAILURE = 'TAN_REQUEST_FAILURE';
export var TAN_VALIDATE_START = 'TAN_VALIDATE_START';
export var TAN_VALIDATE_SUCCESS = 'TAN_VALIDATE_SUCCESS';
export var TAN_VALIDATE_FAILURE = 'TAN_VALIDATE_FAILURE';
export var TAN_RESEND_START = 'TAN_RESEND_START';
export var TAN_RESEND_SUCCESS = 'TAN_RESEND_SUCCESS';
export var TAN_RESEND_FAILURE = 'TAN_RESEND_FAILURE';
export var SHOW_FLAECHEN_TOGGLE = 'SHOW_FLAECHEN_TOGGLE';
export var SAVE_BESTOCKTER_ZUGANG_VALUES = 'SAVE_BESTOCKTER_ZUGANG_VALUES';
export var CLEAR_BESTOCKTER_ZUGANG_VALUES = 'CLEAR_BESTOCKTER_ZUGANG_VALUES';
export var SHOW_FULL_FILTER_TOGGLE = 'SHOW_FULL_FILTER_TOGGLE';
export var showMessage = function (level, message) { return ({
    type: MESSAGE_SHOW,
    level: level,
    message: message,
}); };
export var hideAllMessages = function () { return ({
    type: MESSAGE_HIDE,
}); };
export var tanRequestStart = function () { return ({
    type: TAN_REQUEST_START,
}); };
export var tanRequestSuccess = function (betriebNr, meldungsmodus) { return ({
    type: TAN_REQUEST_SUCCESS,
    betriebNr: betriebNr,
    meldungsmodus: meldungsmodus,
}); };
export var tanRequestFailure = function (error) { return ({
    type: TAN_REQUEST_FAILURE,
    error: error,
}); };
export var tanValidateStart = function () { return ({
    type: TAN_VALIDATE_START,
}); };
export var tanValidateSuccess = function (betriebNr, meldungsmodus) { return ({
    type: TAN_VALIDATE_SUCCESS,
    betriebNr: betriebNr,
    meldungsmodus: meldungsmodus,
}); };
export var tanValidateFailure = function (error) { return ({
    type: TAN_VALIDATE_FAILURE,
    error: error,
}); };
export var tanResendStart = function () { return ({
    type: TAN_RESEND_START,
}); };
export var tanResendSuccess = function (betriebNr, meldungsmodus) { return ({
    type: TAN_RESEND_SUCCESS,
    betriebNr: betriebNr,
    meldungsmodus: meldungsmodus,
}); };
export var tanResendFailure = function (error) { return ({
    type: TAN_RESEND_FAILURE,
    error: error,
}); };
export var toggleShowFlaechen = function () { return ({
    type: SHOW_FLAECHEN_TOGGLE,
}); };
export var saveBestockterZugangValues = function (values) { return ({
    type: SAVE_BESTOCKTER_ZUGANG_VALUES,
    values: values,
}); };
export var clearBestockterZugangValues = function () { return ({
    type: CLEAR_BESTOCKTER_ZUGANG_VALUES,
}); };
export var showFullFilterToggle = function () { return ({
    type: SHOW_FULL_FILTER_TOGGLE,
}); };
